export const setGtag = (): void => {
	function gtag() {
		// Sonar arguments spread is not possible since prototype is deleted
		// biome-ignore lint/complexity/noArguments: Google implementation
		window.dataLayer.push(arguments) //NOSONAR
	}
	window.gtag = gtag
}
